export default () => ({
  withBatchComments: true,
  isDraftsFetched: false,
  drafts: [],
  isPublishing: false,
  currentlyPublishingDrafts: [],
});
